import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const ROLE_META = {
  super_admin: { label: "Super Admin", dashboard: "VS Command Center", home: "/app/overview" },
  client: { label: "Client", dashboard: "Client Workspace", home: "/app/overview" },
  vendor: { label: "Vendor", dashboard: "Vendor Workspace", home: "/app/overview" },
  staffing: { label: "Staffing Company", dashboard: "Staffing Command Center", home: "/app/overview" },
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon
  const [organization, setOrganization] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrganization(data.organization);
    } catch {
      setUser(false);
      setOrganization(null);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("vs_token")) refresh();
    else setUser(false);
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vs_token", data.token);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return data; // { status: "pending_verification", email }
  };

  const verifyEmail = async (email, code) => {
    const { data } = await api.post("/auth/verify-email", { email, code });
    localStorage.setItem("vs_token", data.token);
    await refresh();
    return data.user;
  };

  const resendOtp = async (email) => {
    const { data } = await api.post("/auth/resend-otp", { email });
    return data;
  };

  const adminLogin = async (password) => {
    const { data } = await api.post("/auth/admin-login", { password });
    localStorage.setItem("vs_token", data.token);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("vs_token");
    setUser(false);
    setOrganization(null);
  };

  return (
    <AuthContext.Provider value={{ user, organization, setOrganization, login, register, verifyEmail, resendOtp, adminLogin, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
